import { render, staticRenderFns } from "./notificationsGlobal.vue?vue&type=template&id=16f024f2&"
import script from "./notificationsGlobal.vue?vue&type=script&lang=js&"
export * from "./notificationsGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports